// extracted by mini-css-extract-plugin
export default {"blueSp":"SeperatorBlue_blueSp__1FntC"};